import React from "react";
import { Fade } from "react-awesome-reveal";
import ImageMbl from "../../images/img.png";
import "./style.css";
function ComponentsTwo() {
  return (
    <div className="container maindiv">
      <div className="row">
        <div className="col-lg-4 col-md-5 col-sm-12 mt-5 d-flex justify-content-center align-items-center flex-column mblview2332">
          <Fade direction="up" triggerOnce="true">
            <p className="fs-1 text-white text-start mb-5 textclass">
              No need of notes
            </p>
            <p className="fs-3 text-white text-start  textclass1 ">
              Now you can create your different
              <br /> profiles according to your need
              <br /> and requirements within the app
            </p>
          </Fade>
        </div>
        <div className="col-lg-4 col-md-3 col-sm-12  d-flex justify-content-center align-items-center mblview22">
          <img className="  mblview" src={ImageMbl} alt="" />
        </div>
      </div>
    </div>
  );
}

export default ComponentsTwo;
